// extracted by mini-css-extract-plugin
export default {"history-item":"UserHistoryModalContent_history-item__jspF0","empty-item":"UserHistoryModalContent_empty-item__Ko7uC"};